import { useEffect } from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
// hooks
import { useResponsive } from 'hooks/use-responsive';
// hooks
import { useAuthContext } from 'auth/hooks';
// components
import Logo from 'components/logo';
import Scrollbar from 'components/scrollbar';
import { usePathname } from 'routes/hook';
import { NavSectionVertical } from 'components/nav-section';
//
import { ADMIN_EMAIL } from 'config-global';
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../common';

// ----------------------------------------------------------------------

type Props = {
    openNav: boolean;
    onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
    const { user } = useAuthContext();

    const pathname = usePathname();

    const lgUp = useResponsive('up', 'lg');

    const navData = useNavData();

    useEffect(() => {
        if (openNav) {
            onCloseNav();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    const renderContent = (
        <Scrollbar
            sx={{
                height: 1,
                '& .simplebar-content': {
                    height: 1,
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            {/* <Logo sx={{ mt: 3, ml: 4, mb: 1 }} /> */}
            <Box component="img" src="/logo/logo_single.png" sx={{ width: 120, ml: 3 }} />
            <NavSectionVertical
                data={navData}
                config={{
                    currentRole: user?.primaryEmail === ADMIN_EMAIL ? 'admin' : 'user'
                    // currentRole: user?.primaryEmail === ADMIN_EMAIL ? 'admin' : 'user'
                }}
            />

            <Box sx={{ flexGrow: 1 }} />
        </Scrollbar>
    );

    return (
        <Box
            component="nav"
            sx={{
                flexShrink: { lg: 0 },
                width: { lg: NAV.W_VERTICAL }
            }}
        >
            <NavToggleButton />

            {lgUp ? (
                <Stack
                    sx={{
                        height: 1,
                        position: 'fixed',
                        width: NAV.W_VERTICAL,
                        borderRight: (theme) => `dashed 1px ${theme.palette.divider}`
                    }}
                >
                    {renderContent}
                </Stack>
            ) : (
                <Drawer
                    open={openNav}
                    onClose={onCloseNav}
                    PaperProps={{
                        sx: {
                            width: NAV.W_VERTICAL
                        }
                    }}
                >
                    {renderContent}
                </Drawer>
            )}
        </Box>
    );
}
